<template lang="pug">
.admin-user-search
  v-toolbar(
    dark
    color="indigo"
    flat)
    v-toolbar-title 搜尋會員  
  v-container(fluid)
    v-layout(v-if="!table")
      v-flex
        user-search-form(ref="form")
        .caption.error--text(xs12)
          span {{ message }}
    v-layout(justify-center)
      v-flex(shrink)
        v-btn(
          v-if="!table"
          :loading="loading"
          color="indigo"
          outline
          @click="submit") 送出
        v-btn(
        v-else
          color="indigo"
          outline
          @click="table = false") 返回條件搜尋會員
    v-layout(v-if="table")
      v-flex
        user-table(
          :items="items"
          @submit-succeed="updateTableItem")
</template>

<script>
import { db } from "@/firebase";
import get from "lodash/get";
import UserSearchForm from "@/components/forms/UserSearchForm.vue";
import UserTable from "@/components/tables/UserTable.vue";

export default {
  name: "AdminUserSearch",
  components: {
    UserSearchForm,
    UserTable
  },
  data() {
    return {
      loading: false,
      table: false,
      message: "",
      items: []
    };
  },
  methods: {
    async updateTableItem(user) {
      const { uid } = user;
      const doc = await db
        .collection("users")
        .doc(uid)
        .get();
      const data = doc.data();

      const afterItem = data;
      data.uid = uid;

      const itemIndex = this.items.findIndex(o => o.uid === uid);

      this.items.splice(itemIndex, 1, afterItem);
    },
    async submit() {
      this.loading = true;

      try {
        const list = await this.$refs.form.submit();

        if (!list) {
          return (this.loading = false);
        }

        this.items = list;
        this.table = true;
      } catch (e) {
        this.message = get(e, "response.data.message");
      }

      this.loading = false;
    }
  }
};
</script>
